import { DSNCAd, DSResource } from 'shared-definitions/types'
import { ApiComponent, ApiComponentAd } from 'data-source/types.wp'

interface AdOpts<T extends DSResource, A extends ApiComponent> {
  componentItemMapper: (input: A) => T | T[]
}

export function ncAd<T extends DSResource, A extends ApiComponent>(
  input: ApiComponentAd<A>,
  opts: AdOpts<T, A>
): DSNCAd<T> {
  return {
    postId: typeof input.post_id === 'number' ? input.post_id : null,
    resource: 'nc-ad',
    id: input.id,
    type: input.placement_type,
    fallback: input.fallback ? input.fallback.flatMap(opts.componentItemMapper) : [],
  }
}
